
import React from 'react';

// Component

import SummaryItem from '../SummaryItem';

const PhoneNumberInfo = props => {
    const {
        phoneText,
        desc,
        value
    } = props;

    if(!value) {
        return null;
    }
    
    return (
        <SummaryItem
            value = { value }
            textCode = { phoneText }
            desc = { desc }
            ignoreIntl
            noPriorDataValues = { [ null ] }
        />
    );
};

export default PhoneNumberInfo;